import { LucideUser } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { StudentReportCard } from "@/components/entities/StudentReportCard";

export function StudentListSheet({
  open,
  onOpenChange,
  students,
  loading,
  currentReportId,
  getLinkPath,
  linkState,
  onSelect,
  onToggleComplete,
  canEdit = true,
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="bg-background text-foreground w-[360px] sm:max-w-md flex flex-col p-0"
      >
        <SheetHeader className="px-6 pt-6 pb-4 border-b border-border">
          <SheetTitle>Students in this Report Folder</SheetTitle>
          <SheetDescription>
            Click a student to jump to their report. Your current changes will be saved.
          </SheetDescription>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-4 py-3">
          {loading ? (
            <div className="space-y-2">
              {[0, 1, 2, 3, 4].map((i) => (
                <div key={i} className="h-9 bg-muted rounded-xl animate-pulse" />
              ))}
            </div>
          ) : students.length === 0 ? (
            <div className="text-center py-12 text-muted-foreground">
              <LucideUser size={32} className="mx-auto mb-2 opacity-40" />
              <p className="text-sm">No other students yet.</p>
            </div>
          ) : (
            <div className="space-y-2">
              {students.map((card) => {
                const isCurrent = card._id === currentReportId;
                return (
                  <div
                    key={card._id}
                    className={isCurrent ? "rounded-xl ring-2 ring-primary" : ""}
                  >
                    <StudentReportCard
                      card={card}
                      linkPath={getLinkPath(card)}
                      linkState={linkState}
                      size="sm"
                      isComplete={card.checkedState === "complete"}
                      onToggleComplete={onToggleComplete}
                      canEdit={canEdit}
                      showMenu={false}
                      onClick={() => onSelect?.(card)}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
